
import { groupBy } from 'lodash';
import { FC } from 'react';

import OrderProductRow from 'containers/PosOrderDetailsPage/OrderProductRow';

import { OrderItem } from 'types/pos.interface';

import {
  CardProductsWrapper,
} from './index.styled';

interface OrderProductsListProps {
  products: OrderItem[];
}

const OrderProductsList: FC<OrderProductsListProps> = ({ products }: OrderProductsListProps) => {
  const groupedItems = groupBy(products, 'itemId');

  return (
    <CardProductsWrapper>
      {Object.entries(groupedItems).map(([key, value]) => (
        <OrderProductRow key={key} products={value as OrderItem[]} />
      ))}
    </CardProductsWrapper>
  );
};

export default OrderProductsList;
